import { DataInStatsModel, DataLakeModel, OverallStatsModel } from '@/models/data-lake/data-lake';
import { sortByProperty } from '@/utils/utils';

export class DatalakeSerializer {

    private static INSTANCE = new DatalakeSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeDatalakeData(payload: any) {
        const stats: any = payload.stats || {};
        const datalakeDataIn  = payload.datalake_datain_stats || [];
        const overallStats: OverallStatsModel = {
            currentMonthContentProviderVol: stats.current_month_content_provider_volume_size || 0,
            currentMonthToolProviderVol: stats.current_month_tool_provider_volume_size || 0,
            overallToolProviderVol: stats.overall_tool_provider_volume_size || 0,
            overallContentProviderVol: stats.overall_content_provider_volume_size || 0,
            currentMonthVol: (stats.current_month_content_provider_volume_size || 0)
                 + (stats.current_month_tool_provider_volume_size || 0),
            overallVol: (stats.overall_tool_provider_volume_size || 0)
                 + (stats.overall_content_provider_volume_size || 0),
        } as OverallStatsModel;
        const datalakeDataInStats: DataInStatsModel[] = [];
        datalakeDataIn.forEach((item: any) => {
            const dataInItem: DataInStatsModel = {
                id: item.learning_tool_provider_id || item.learning_content_provider_id,
                toolName: item.learning_tool_provider_name || item.learning_content_provider_name,
                tenantId: item.tenant_id,
                isPublisher: !!item.learning_content_provider_name,
                grades: (item.grades || ['All']).join(','),
                subjects: (item.subjects || ['All']).join(','),
                volume: parseInt(item.volume, 0),
                createdAt: item.created_at,
                updatedAt: item.updated_at,
            };
            datalakeDataInStats.push(dataInItem);
        });
        sortByProperty(datalakeDataInStats, 'volume', 'DESC');
        return {
            overallStats,
            datalakeDataInStats,
        } as DataLakeModel;
    }

    public normalizeDatalakeTools(payload: any) {
        const payloadData  = payload.datalake_datain_stats || [];
        const datalakeDataInStats: DataInStatsModel[] = [];
        payloadData.forEach((item: any) => {
            const dataInItem: DataInStatsModel = {
                id: item.learning_tool_provider_id || item.learning_content_provider_id,
                toolName: item.learning_tool_provider_name || item.learning_content_provider_name,
                tenantId: item.tenant_id,
                fileName: item.filename,
                isPublisher: !!item.learning_content_provider_name,
                grades: (item.grades || ['All']).join(','),
                subjects: (item.subjects || ['All']).join(','),
                volume: parseInt(item.volume, 0),
                createdAt: item.created_at,
                updatedAt: item.updated_at,
            };
            datalakeDataInStats.push(dataInItem);
        });
        return {
            datalakeDataInStats,
            totalCounts: payload.total_count,
        };
    }

}

export const datalakeSerializer = DatalakeSerializer.instance;
